import { createContext, useContext, useEffect } from 'react';

/** What the sidebar's part that holds the viewer on the pin offers it. */
export type PinViewerNavigationLock = {
  /** Esc: the part lets go, asking the user first when it holds a draft. */
  requestLeave(): void;
};

/** Set by `PinViewer` around its sidebar: locks or frees leaving the pin, by another pin or by closing. */
export const PinViewerNavigationLockContext = createContext<
  ((lock: PinViewerNavigationLock | null) => void) | null
>(null);

/**
 * While `locked`, the viewer shows the same pin and stays open whatever the
 * user does (a draft in the sidebar belongs to it); Esc goes to
 * `requestLeave` instead. Leaves with the caller: unmounting frees the
 * viewer. Does nothing outside a `PinViewer`.
 */
export function useLockPinViewerNavigation(
  locked: boolean,
  requestLeave: () => void
) {
  const setLock = useContext(PinViewerNavigationLockContext);
  useEffect(() => {
    if (!setLock || !locked) return;
    setLock({ requestLeave });
    return () => setLock(null);
  }, [setLock, locked, requestLeave]);
}
